module.exports = __webpack_public_path__ + "img/running.2a12a037.svg";